import { WidgetLineGraph } from '../Widgets';
import { connect } from 'react-redux';
import { getUnSubsData, getUnSubsDataTotal } from '../../redux/actions/unsubs';
import { getSubMethodLookupData } from '../../redux/actions/subs';
import { sumByField, formatDateFromRange } from '../../helpers';

const mapStateToProps = (state, ownProps) => ({
  id: 'WidgetUnsubs',
  className: ownProps.className,
  width: ownProps.width,
  height: ownProps.height,
  graph: state.unsubs.WidgetUnsubs
    && state.unsubs.WidgetUnsubs.data
    && state.filter.filters.endDate
    && state.filter.filters.startDate ? [state.unsubs.WidgetUnsubs.data.map(item => ({ key: formatDateFromRange(item.dt, state.filter.filters), value: item.ns , dt: item.dt}))] : [],
  exportData: state.unsubs.WidgetUnsubs && state.unsubs.WidgetUnsubs.data && state.filter.filters.endDate && state.filter.filters.startDate ? state.unsubs.WidgetUnsubs.data.map(item => ({ dt: item.dt, "UnSubscribers": item.ns})) : [],
  info: state.unsubs.WidgetUnsubs && state.unsubs.WidgetUnsubs.totalData && state.subs.lookupData ? state.unsubs.WidgetUnsubs.totalData.filter(item => item._id).map(item => ({
      amount: (item['ns']/sumByField(state.unsubs.WidgetUnsubs.data, 'ns')) * 100 ,
      type: 'percentage',
      description: (state.subs.lookupData.filter(i => (i.id === item._id)).length !== 0 ? state.subs.lookupData.filter(i => (i.id === item._id))[0].value : '')
    })).concat({
      amount: sumByField(state.unsubs.WidgetUnsubs.data, 'ns'),
      description: "Unsubs (Total)",
    }) : [],
  filters: {
    oc: state.filter.filters.oc,
    srvcId: state.filter.filters.service,
    startDate: state.filter.filters.startDate,
    endDate: state.filter.filters.endDate,
    tz: state.filter.filters.tz
  },
  colorScheme: ownProps.colorScheme,
  title: ownProps.title,
  onZoom: ownProps.onZoom,
  dataLoaded: state.unsubs.WidgetUnsubs && state.unsubs.WidgetUnsubs.loaded,
  filtersLoaded: state.filter.filters.oc
    && state.filter.filters.service
    && state.filter.filters.endDate
    && state.filter.filters.startDate,
  loaded: state.unsubs.WidgetUnsubs
    && state.unsubs.WidgetUnsubs.loaded
    && state.filter.filters.oc
    && state.filter.filters.service
    && state.filter.filters.endDate
    && state.filter.filters.startDate,
  shouldLoadData: !state.unsubs.WidgetUnsubs || (!state.unsubs.WidgetUnsubs.loaded && !state.unsubs.WidgetUnsubs.loading && !state.unsubs.WidgetUnsubs.error),
  drillOptions: ['Unsub-Method'],
  drillData: [
    {
      label: 'Unsub-Method',
      param: 'unsubMethod',
      onClick: ownProps.drillClick,
      widgetType: 'WidgetPieDrillUnsubs',
      widgetTitle: 'Unsubs Data - Unsub-Method'
    }
  ],

})

const mapDispatchToProps = (dispatch) => ({
  fetchData: (params, graphId) => {
    dispatch(getUnSubsData(params, graphId));
    dispatch(getUnSubsDataTotal(params, graphId));
    dispatch(getSubMethodLookupData({param:'unsubMethod'}, graphId));
  }
})

export default connect(mapStateToProps, mapDispatchToProps)(WidgetLineGraph)



// WEBPACK FOOTER //
// ./src/components/ConnectedWidgets/WidgetUnsubsConnected.js